var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isDismissed)?_c('gl-alert',{attrs:{"variant":_vm.type,"dismissible":_vm.dismissible},on:{"dismiss":_vm.onDismiss}},[_vm._t("default"),_vm._v(" "),(_vm.helpPath)?_c('gl-link',{staticClass:"gl-label-link",attrs:{"href":_vm.helpPath,"target":"_blank"}},[_vm._t("link-content")],2):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }